var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan"},[_c('condition'),_c('course',{attrs:{"editable":_vm.editable}}),_c('plan-price'),_c('control')],1)}
var staticRenderFns = []

export { render, staticRenderFns }